export default __webpack_public_path__ + "static/media/sidebar.017608be.jpg";